var fallbackWindow = {};
export function locateWindow() {
    if (typeof window !== "undefined") {
        return window;
    }
    else if (typeof self !== "undefined") {
        return self;
    }
    return fallbackWindow;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/util-locate-window/dist-es/index.js
// module id = 194
// module chunks = 0